module.exports = __webpack_public_path__ + "img/cover.e3b1718f.jpg";